import { lazy } from 'react';
import type { RouteObject } from 'react-router';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const DocumentationPage = lazy(() => import('./pages/Documentation'));
const TestInboxPage = lazy(() => import('./pages/TestInbox'));

/** Documentação pública (raiz do site) e caixa de testes. */
const routes: RouteObject[] = [
  { path: '/', element: <DocumentationPage /> },
  { path: '/documentacao', element: <DocumentationPage /> },
  { path: '/caixa-de-testes', element: <TestInboxPage /> },
];
export default routes;
